import { FETCH_RAINPRO_POINT_PACKAGES, CLEAN_RAINPRO_POINT_PACKAGES } from '../actions/types';

const RAINPRO_POINT_PACKAGES_DEFAULT_STATE = {};

const RainproPointPackagesReducer = (state = RAINPRO_POINT_PACKAGES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_POINT_PACKAGES:
            return payload;

        case CLEAN_RAINPRO_POINT_PACKAGES:
            return RAINPRO_POINT_PACKAGES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default RainproPointPackagesReducer;
